export default "__VITE_ASSET__C5l$WSZ8__"